import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import { g as grayscale } from './p-c4d8f7e9.js';
import { a3 as getDesignTokenValue } from './p-a57042e3.js';
import { a as accessibilityAttributes } from './p-756e7dc5.js';
import { a as ComponentUtils } from './p-de830ba7.js';
const badgeCss = ".sc-owc-badge-h{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:var(--one-spacing-radius-100);min-width:var(--one-spacing-size-4-xs);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-badge-font-size);line-height:var(--one-typography-desktop-badge-line-height);-webkit-font-kerning:var(--one-typography-desktop-badge-font-kerning);font-kerning:var(--one-typography-desktop-badge-font-kerning);font-weight:var(--one-text-font-weight-bold)}.owc-badge--status-info.sc-owc-badge-h{color:var(--one-color-foreground-intensity-lowest);background-color:var(--one-color-background-intensity-medium)}.owc-badge--status-active.sc-owc-badge-h{color:var(--one-color-foreground-intensity-lowest);background-color:var(--one-color-background-brand-base)}.owc-badge--status-alarm.sc-owc-badge-h{color:var(--one-color-foreground-intensity-lowest);background-color:var(--one-color-background-negative-base)}.owc-badge--status-warning.sc-owc-badge-h{color:var(--one-color-foreground-contrast-lowest);background-color:var(--one-color-background-warning-base)}.owc-badge--status-positive.sc-owc-badge-h{color:var(--one-color-foreground-intensity-lowest);background-color:var(--one-color-background-positive-base)}.owc-badge--status-custom.sc-owc-badge-h{color:var(--custom-foreground-color);background-color:var(--custom-background-color)}.owc-badge--size-small.sc-owc-badge-h{padding:var(--one-spacing-padding-none) var(--one-spacing-padding-5-xs);min-height:var(--one-spacing-size-2-xs);min-width:var(--one-spacing-size-2-xs)}@media (forced-colors: active){.owc-badge--size-small.sc-owc-badge-h{color:canvastext}}.owc-badge--size-medium.sc-owc-badge-h{padding:var(--one-spacing-padding-5-xs) var(--one-spacing-padding-4-xs);min-height:var(--one-spacing-size-s);min-width:var(--one-spacing-size-s)}@media (forced-colors: active){.owc-badge--size-medium.sc-owc-badge-h{color:canvastext}}.owc-badge--size-xSmall.sc-owc-badge-h{min-height:var(--one-spacing-size-4-xs);font-size:var(--one-spacing-size-none);line-height:var(--one-spacing-size-none)}@media (forced-colors: active){.owc-badge--size-xSmall.sc-owc-badge-h{outline:var(--one-spacing-outline-regular) solid canvastext;outline-offset:calc(var(--one-spacing-outline-regular) * -1);background-color:buttonface}.owc-badge--size-xSmall.owc-badge--disabled.sc-owc-badge-h{outline-color:graytext}}.owc-badge--disabled.sc-owc-badge-h{color:var(--one-color-interaction-disabled-intensity-medium);background-color:var(--one-color-interaction-disabled-intensity-lower)}@media (forced-colors: active){.owc-badge--disabled.sc-owc-badge-h{color:graytext}}";
const OwcBadgeStyle0 = badgeCss;
const CUSTOM_FOREGROUND_COLOR = '--custom-foreground-color';
const CUSTOM_BACKGROUND_COLOR = '--custom-background-color';
const Badge = /*@__PURE__*/proxyCustomElement(class Badge extends H {
  constructor() {
    super();
    this.__registerHost();
    this.updateColors = () => {
      const foregroundColor = grayscale(getDesignTokenValue(`--one-color-${this.color}`)) <= 128 ? '--one-color-foreground-intensity-lowest' : '--one-color-foreground-base';
      this.customFgColor = foregroundColor;
    };
    this.component = new ComponentUtils(this);
    this.status = 'info';
    this.size = 'medium';
    this.disabled = false;
    this.hostRole = 'status';
    this.color = 'background-base';
    this.customFgColor = '--one-color-foreground-base';
  }
  onColorChanged() {
    this.updateColors();
  }
  componentDidLoad() {
    this.status === 'custom' && this.updateColors();
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`status-${this.status || 'info'}`]: true,
      [`size-${this.size || 'medium'}`]: true,
      disabled: this.disabled
    });
    return h(Host, Object.assign({
      key: 'b8102772d5c0be7a1f697693017bf616a7caff88',
      class: hostClasses,
      style: {
        [CUSTOM_FOREGROUND_COLOR]: `var(${this.customFgColor})`,
        [CUSTOM_BACKGROUND_COLOR]: `var(--one-color-${this.color})`
      }
    }, accessibilityAttributes({
      disabled: !!this.disabled,
      live: this.disabled || this.hostRole === 'presentation' ? 'off' : 'polite'
    })), h("slot", {
      key: 'de392ad06f89885b611998decaeadeb881c9820a'
    }));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "color": ["onColorChanged"]
    };
  }
  static get style() {
    return OwcBadgeStyle0;
  }
}, [6, "owc-badge", {
  "status": [513],
  "size": [513],
  "disabled": [516],
  "hostRole": [1, "role"],
  "color": [513],
  "customFgColor": [32]
}, undefined, {
  "color": ["onColorChanged"]
}]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-badge"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-badge":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Badge);
        }
        break;
    }
  });
}
export { Badge as B, defineCustomElement as d };